<template>
    <div id="shell">
        <div class="bar" :style="{ width: scale + '%' }">
            <label v-if="scale > 0">{{ scale }}%</label>
            <span class="blank" v-else>0%</span>
        </div>
    </div>
</template>
<script>

export default {
    name: 'ProgressBar',
    props:['scale'],
}
</script>
<style lang="scss">
#shell {
  width: 250px;
  border-radius: 13px;
  // padding: 2px;
  // box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.25), inset 0 1px 10px rgba(0, 0, 0, 0.15), 0 1px rgba(255, 255, 255, 1);
  // overflow: hidden;
  position: relative;
  .bar {
    background: linear-gradient(to right, #f0ad4e, #5cb85c);
    height: 20px;
    width: 15px;
    border-radius: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all 0.3s ease-in-out;
    z-index: 2; 
    label {
      padding: 4px 5px;
      color: #fff;
      font-weight: 500;
      display:flex;
      font-size: 11px;
      line-height: 13px;   
    }
    .blank{
        position: absolute;
        top: 50%;
        left: 10px;
        color: #333;
        font-size: 11px;
        line-height: 13px;
        font-weight: 500;
        transform: translateY(-50%);
        z-index: 1;
    }
  }
  &:after{
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 13px;
      box-shadow: inset 0 1px 2px rgba(61, 44, 44, 0.2), inset 0 1px 10px rgba(0, 0, 0, 0.2), 0 1px rgba(255, 255, 255, 1);
      z-index: 2;
  }
}
</style>